
import React from 'react';

export default React.createClass({

    displayName: 'ColorView',

    render() {
        return (
            <div>
                <h1>Color VIEW</h1>
            </div>
        )
    },

});



/** WEBPACK FOOTER **
 ** ./examples/ColorsView.js
 **/